// @react/hooks/useSubscriptionAddon.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { subscriptionAddonStore } from '@core/stores';

/**
 * React hook for AddOn operations.
 * Uses MobX store directly - wrap components with observer() for reactivity.
 *
 * @example
 * ```tsx
 * import { observer } from '@react';
 * import { useSubscriptionAddon } from '@react/hooks';
 *
 * const AddOnList = observer(() => {
 *   const store = useSubscriptionAddon();
 *
 *   useEffect(() => {
 *     store.items; // access observable state
 *   }, []);
 *
 *   if (store.isLoading) return <div>Loading...</div>;
 *
 *   return (
 *     <ul>
 *       {store.items.map(item => <li key={item.id}>{item.name}</li>)}
 *     </ul>
 *   );
 * });
 * ```
 */
export function useSubscriptionAddon() {
  return subscriptionAddonStore;
}
